import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { SharedDataService } from '../../services/shared-data.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-confirm-box-field',
    templateUrl: './confirm-box-field.component.html',
    styleUrls: ['./confirm-box-field.component.scss'],
})
export class ConfirmBoxFieldComponent implements OnInit, OnDestroy {
    UtilService = UtilService;

    @Input() inputName: string;
    @Input() form: UntypedFormGroup;
    @Input() list: Array<any>;
    @Input() questionId: number;
    @Input() preValue: boolean;

    private formSubscription: Subscription;

    @Output() answerUpdated = new EventEmitter<{ questionId: number; isChecked: boolean }>();

    constructor(public sharedDataService: SharedDataService) { }

    ngOnInit() {
		if (this.preValue) {
            const box = document.querySelector(`[id$="${this.questionId}"]`)?.querySelector('ion-checkbox') as HTMLIonCheckboxElement
            this.sharedDataService.updateConfirmBoxState({ confirmBoxId: this.questionId, isChecked: true });
            box.checked = true
            
            setTimeout(()=>{
                if(this.preValue){
                    this.form.get(this.inputName)?.setValue(this.preValue);
                    this.formSubscription = this.form.get(this.inputName).valueChanges.subscribe((value) => {
                        const box = document.querySelector(`[id$="${this.questionId}"]`)?.querySelector('ion-checkbox') as HTMLIonCheckboxElement
                        this.sharedDataService.updateConfirmBoxState({ confirmBoxId: this.questionId, isChecked: !box.ariaChecked });
                        this.answerUpdated.emit({ questionId: this.questionId, isChecked: value });
                        if(box){
                            if(box.ariaChecked === "true"){
                                box.checked = false
                            } else {
                                box.checked = true
                            }
                        }
                    });   
                }
            },2000)
        } else{
            this.formSubscription = this.form.get(this.inputName).valueChanges.subscribe((value) => {
                this.sharedDataService.updateConfirmBoxState({ confirmBoxId: this.questionId, isChecked: value });
                this.answerUpdated.emit({ questionId: this.questionId, isChecked: value });
            });
    }
    }

    ngOnDestroy() {
        // Unsubscribe to prevent memory leaks when the component is destroyed
        if (this.formSubscription) {
            this.formSubscription.unsubscribe();
        }
    }
}
